// src/components/RoleProtectedRoute.jsx
import ProtectedRoute from "./ProtectedRoute";

export default function RoleProtectedRoute({ children, allow = [] }) {
  return <ProtectedRoute allowRoles={allow}>{children}</ProtectedRoute>;
}
